import React from 'react';
import { Presentation } from './components/Presentation';
export function App() {
  return <div className="w-full min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 font-sans" data-id="element-0">
      <Presentation data-id="element-1" />
    </div>;
}